import Vue from 'vue'
import App from './App'
import vuetify from '@/plugins/vuetify';
import Multiselect from 'vue-multiselect';
import Vuex from 'vuex';
import store from './store/store';
import JsonExcel from 'vue-json-excel'
import VueRouter from 'vue-router'
import router from './router';

Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.component('multiselect', Multiselect);
Vue.component('downloadExcel', JsonExcel)

/* eslint-disable no-new */
new Vue({
    router,
    vuetify,
    store,
    el: '#app',
    components: { App },
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js